import { useState, useEffect } from 'react';
import iframeDetector from '../utils/IframeDetector';

/**
 * React hook for iframe detection
 * 
 * This hook provides a simple way to detect if the application
 * is running inside an iframe and react to that state.
 * 
 * @returns {Object} Detection state and utilities
 */
export default function useIframeDetection() {
  const [isInIframe, setIsInIframe] = useState(false);
  const [detectionDetails, setDetectionDetails] = useState([]);
  const [parentInfo, setParentInfo] = useState(null);

  useEffect(() => {
    // Perform detection on mount
    const inIframe = iframeDetector.isInIframe();
    const details = iframeDetector.getDetectionDetails();
    const parent = iframeDetector.getParentInfo();

    setIsInIframe(inIframe);
    setDetectionDetails(details);
    setParentInfo(parent);

    // Set up a periodic check (every 2 seconds) to detect dynamic iframing
    const intervalId = setInterval(() => {
      iframeDetector.redetect();
      const newState = iframeDetector.isInIframe();
      
      if (newState !== isInIframe) {
        setIsInIframe(newState);
        setDetectionDetails(iframeDetector.getDetectionDetails());
        setParentInfo(iframeDetector.getParentInfo());
      }
    }, 2000);

    // Cleanup interval on unmount
    return () => clearInterval(intervalId);
  }, [isInIframe]);

  return {
    isInIframe,
    detectionDetails,
    parentInfo,
    detector: iframeDetector
  };
}

